import { render } from "./stock.vue?vue&type=template&id=ca97481a"
import script from "./stock.vue?vue&type=script&lang=js"
export * from "./stock.vue?vue&type=script&lang=js"

import "./stock.vue?vue&type=style&index=0&id=ca97481a&lang=less"
script.render = render

export default script